import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

const LanguageToggle = () => {
  const { i18n, t } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "fr").startsWith("en") ? "en" : "fr";
  const next = current === "fr" ? "en" : "fr";

  return (
    <Button
      variant="ghost"
      size="sm"
      className="h-9 px-3 text-xs font-semibold tracking-wide uppercase"
      onClick={() => i18n.changeLanguage(next)}
      aria-label={t("langToggle.switchTo")}
      title={t("langToggle.switchTo")}
    >
      {current === "fr" ? "EN" : "FR"}
    </Button>
  );
};

export default LanguageToggle;
